var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('VueLightbox',{class:'text-box',attrs:{"index":_vm.idx,"toolbar":_vm.toolbar,"items":_vm.source,"video":{ autoplay: true, width: 'auto', muted: false, }},on:{"chang":e => _vm.idx = e,"close":function($event){_vm.idx = null}}}),_vm._t("default",null,{"show":src => _vm.showImg(src)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }